const STORAGE_CLO_TOKEN = 'token'
const STORAGE_CLO_DOCUMENT_ID = 'offerDocumentId'
const STORAGE_CLO_AGENT_ID = 'agentId'
const STORAGE_CLO_ROLES = 'roles'
const STORAGE_LANGUAGE = 'i18nextLng'

export const getToken = () => sessionStorage.getItem(STORAGE_CLO_TOKEN)

export const existsToken = () => !!sessionStorage.getItem(STORAGE_CLO_TOKEN)

export const saveToken = token =>
  sessionStorage.setItem(STORAGE_CLO_TOKEN, token)

export const getUserRoles = () => {
  const userStringRoles = sessionStorage.getItem(STORAGE_CLO_ROLES)
  return JSON.parse(userStringRoles) as string[]
}

export const saveUserRoles = (roles: string[]) =>
  sessionStorage.setItem(STORAGE_CLO_ROLES, JSON.stringify(roles))

export const existsOfferDocument = () =>
  !!sessionStorage.getItem(STORAGE_CLO_DOCUMENT_ID)

export const getOfferDocumentId = () =>
  sessionStorage.getItem(STORAGE_CLO_DOCUMENT_ID)

export const saveOfferDocumentId = (id: string) =>
  sessionStorage.setItem(STORAGE_CLO_DOCUMENT_ID, id)

export const getUserName = () => sessionStorage.getItem(STORAGE_CLO_AGENT_ID)

export const saveAgentUserName = (id: string) =>
  sessionStorage.setItem(STORAGE_CLO_AGENT_ID, id)

export const getDefaultSelectedLanguage = () => {
  const defaultLanguage = localStorage.getItem(STORAGE_LANGUAGE)
  return defaultLanguage
}

export const clearStorage = () => sessionStorage.clear()

export const clearOfferDocumentId = () =>
  sessionStorage.removeItem(STORAGE_CLO_DOCUMENT_ID)

export const clearUserName = () =>
  sessionStorage.removeItem(STORAGE_CLO_AGENT_ID)

export const clearToken = () => sessionStorage.removeItem(STORAGE_CLO_TOKEN)
